import { createAction, createApiAction, createErrorAction } from '@saucelabs/sl-util-redux';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as api from './api';
import * as types from './types';

export const saveTableOffset = createAction(types.UPDATE_OFFSET);
export const getUserList = createApiAction(types.USERLIST_GET, (payload) => (
  api.getUsers(payload)
));

export const patchUserRequest = createAction(types.USER_PATCH.REQUEST);
export const patchUserSuccess = createAction(types.USER_PATCH.SUCCESS);
export const patchUserFailure = createErrorAction(types.USER_PATCH.FAILURE);

export const teamAssignment = createApiAction(
  types.TEAM_ASSIGNMENT,
  (payload) => api.postMembership(payload),
);

export const updateRoleRequest = createAction(types.ROLE_UPDATE.REQUEST);
export const updateRoleSuccess = createAction(types.ROLE_UPDATE.SUCCESS);
export const updateRoleFailure = createErrorAction(types.ROLE_UPDATE.FAILURE);

export const deactivateUserRequest = createAction(types.USER_DEACTIVATE.REQUEST);
export const deactivateUserSuccess = createAction(types.USER_DEACTIVATE.SUCCESS);
export const deactivateUserFailure = createErrorAction(types.USER_DEACTIVATE.FAILURE);

export const reactivateUserRequest = createAction(types.USER_REACTIVATE.REQUEST);
export const reactivateUserSuccess = createAction(types.USER_REACTIVATE.SUCCESS);
export const reactivateUserFailure = createErrorAction(types.USER_REACTIVATE.FAILURE);

export const removeMembershipRequest = createAction(types.MEMBERSHIP_REMOVE.REQUEST);
export const removeMembershipSuccess = createAction(types.MEMBERSHIP_REMOVE.SUCCESS);
export const removeMembershipFailure = createErrorAction(types.MEMBERSHIP_REMOVE.FAILURE);

export const patchOrganizationRequest = createAction(types.PATCH_ORGANIZATION.REQUEST);
export const patchOrganizationSuccess = createAction(types.PATCH_ORGANIZATION.SUCCESS);
export const patchOrganizationFailure = createErrorAction(types.PATCH_ORGANIZATION.FAILURE);

export const updateFilter = createAction(types.TOGGLE_FILTER);
export const clearFilters = createAction(types.CLEAR_FILTERS);

export const getOrganizationUsersUsageCSV = createApiAction(
  types.GET_ORGANIZATION_USERS_USAGE_CSV,
  (payload, meta, dispatch) => (
    api.getOrganizationUsersUsageCSV(payload)
      .catch(() => dispatch(notificationActions.notifyDanger('Something went wrong with CSV creation')))
  ),
);
